module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-700.1dc5b629.ttf";